<div class="container-fluid m-0 p-0" *ngIf="checkDataExist()">
    <div class="row">
        <div class="col-12 mt-4">
            <div class="border-bottom font-16 mb-3 text-bold">{{ "TAB_BASIC_DATA" | translate | titlecase }}</div>
        </div>
        <div class="col-12">
            <div class="row m-0 p-3 bg-light-grey">
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"INTERVIEW_RUBRIC_SCORE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.interviewRscore }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "INTERVIEW_COMMENT" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.interviewComment }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{"INTERVIEW_WRITING_RUBRIC_SCORE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.interviewWritingRscore }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "INTERVIEW_WRITING_COMMENT" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.interviewWritingComment }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ATTITUDE_RUBRIC_SCORE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.attitudeRscore }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "ATTINTUDE_COMMENT" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.attitudeComment }}</p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "INTERVIEW_VIDEO_LINK" | translate | titlecase }}</label>
                    <!-- <p class="cand-answer">{{candData.interviewVduLink }}</p> -->
                    <p class="cand-answer"><a href="{{candData.interviewVduLink }}" target="_blank">{{ "VIEW" |
                            translate | titlecase }}</a></p>
                </div>
                <div class="col-md-4 mb-2">
                    <label class="text-bold font-14">{{ "INTERVIEW_DATE" | translate | titlecase }}</label>
                    <p class="cand-answer">{{candData.interviewDate | date:'yyyy-MM-dd' }}</p>
                </div>

            </div>
        </div>
    </div>
</div>
<app-loader [show]="!checkDataExist()"></app-loader>